module.exports = __webpack_public_path__ + "static/img/img02.25f051f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img02.png
// module id = Jp9Q
// module chunks = 1